import React from 'react'
import Button from '../../components/Button'

const Footer = () => {
  const year = (new Date()).getFullYear();

  return (
    <footer className="site-footer">
      <span className="site-footer__text">
        { year }. Designed & developed with ☕️ by Drew. Check out my <Button link to="https://bitbucket.org/itsme_Drew/itsmedrew_2025/src/main/">Bitbucket</Button>.
      </span>
    </footer>
  );
};

export default Footer;
